/* import __COLOCATED_TEMPLATE__ from './adi-input.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';
import { computed, action } from '@ember/object';
import PrettyNum from '../../utils/pretty-num-wrapper';
import Utils from '../../utils/utils';
import Constants from '../../utils/constants';

const DEFAULT_PRETTY_NUM_TYPE = 'eng3';

export default class AdiInput extends Component {
    @service intl;

    tagName = '';

    popover = {
        show: false,
        message: '',
        showDuration: 5000,
        triggerElement: '',
        triggerEvents: [],
    };

    isPretty = false;

    init() {
        super.init();
        this.set('popover.triggerElement', `#${this.inputId}`);
    }

    @computed('value', 'isPretty') get uiValue() {
        return this.isPretty ? this.prettyNumFn(this.value) : this.value;
    }

    @computed('qaAttrValue') get tooltipAttrText() {
        return `${this.qaAttrValue}_msg`;
    }

    @action handleUIChange() {
        this.set(
            'inputValue',
            (this.value || this.value === 0) && this.isPretty ? this.prettyNumFn(this.value) : this.value,
        );
    }

    @action onKeyDown(event) {
        if (Constants.KEYS.ENTER.includes(event.key)) this.handleValueChange();
    }

    @action onChange() {
        this.handleValueChange();
    }

    handleValueChange() {
        let values = this.getValues();

        // Ensure handling only happens once even if multiple events are triggered
        if (values.hasChanged || values.errorMessage) {
            this.set('value', values.raw);
            this.setInput((values.raw || values.raw === 0) && values.pretty ? values.pretty : values.raw);

            if (values.hasChanged && this.onValueChange) this.onValueChange(this.value);

            if (values.errorMessage) this.displayErrorPopover(values.errorMessage);
        }
    }

    setInput(value) {
        this.set('inputValue', value);
        document.querySelector(`#${this.inputId}`).value = value;
    }

    getValues() {
        let result = {},
            inputValue = document.querySelector(`#${this.inputId}`).value;

        if (this.isPretty) {
            result.raw = PrettyNum.userEntryToNumber(inputValue);

            if (isNaN(result.raw) && Utils.isNumeric(inputValue)) {
                result.raw = Number(inputValue);
            }

            if (isNaN(result.raw)) {
                result.raw = this.value;
                result.errorMessage = this.intl.t('messages.multiplier_numeric');
            }
        } else if (Utils.isNumeric(inputValue)) {
            // Set the precision if provided
            if (this.precision && inputValue.includes('.') && inputValue.length - 1 > Number(this.precision)) {
                inputValue = inputValue.slice(0, Number(this.precision) + (inputValue.startsWith('.') ? 0 : 1));
            }

            result.raw = Number(inputValue);
        } else if (!isNaN(PrettyNum.userEntryToNumber(inputValue))) {
            result.errorMessage = this.intl.t('messages.multiplier');
            result.raw = this.value;
        } else {
            result.errorMessage = this.intl.t('messages.numeric');
            result.raw = this.value;
        }

        if (this.isPretty) {
            result.pretty = this.prettyNumFn(result.raw);
        }

        result.hasChanged = !(this.value === result.raw);

        return result;
    }

    displayErrorPopover(message) {
        let selfRef = this;
        this.set('popover.message', message);
        this.set('popover.show', true);

        this.popoverTimeout = setTimeout(() => {
            if (selfRef._state != 'inDOM') return;
            selfRef.set('popover.show', false);
            selfRef.set('popover.message', '');
        }, this.popover.showDuration);
    }

    prettyNumFn(value) {
        let prettyNumType = this.prettyNumType || DEFAULT_PRETTY_NUM_TYPE;
        return prettyNumType in PrettyNum ? PrettyNum[prettyNumType](value) : value;
    }
}
